import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Building2, LogOut, Plus } from "lucide-react";
import { NAV_ITEMS, Icon } from "./navConfig";

export default function Sidebar({ 
  activeNav, 
  sidebarOpen, 
  setSidebarOpen, 
  initials, 
  companyName, 
  loads = [], 
  activePostings = 0, 
  assignedLoads = 0, 
  totalSpent = 0, 
  handleLogout 
}) {
  const navigate = useNavigate();

  return (
    <aside className={`fixed lg:relative z-50 lg:z-auto top-0 left-0 h-full w-56 flex-shrink-0 flex flex-col transition-transform duration-300 ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
      style={{ background: "#1a2744" }}>
      
      <div className="flex items-center gap-2.5 px-4 py-4 border-b border-white/10 flex-shrink-0">
        
      <Link to="/" className="flex items-center gap-2.5 flex-1 hover:opacity-80 transition-opacity">
          <div className="w-9 h-9 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
            <Building2 className="w-5 h-5 text-white" />
          </div>
          <div>
            <span className="font-bold text-white text-base tracking-wide">COMPANY</span>
            <p className="text-[9px] text-white/40 uppercase tracking-widest mt-0.5">PilotLinkUSA</p>
          </div>
        </Link>
        <button onClick={() => setSidebarOpen(false)} className="ml-auto lg:hidden text-white/50 hover:text-white">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>

      <div className="mx-3 mt-3 rounded-xl p-2.5 flex items-center gap-2.5 flex-shrink-0" style={{ background: "rgba(255,255,255,0.07)" }}>
        <div className="w-8 h-8 rounded-lg bg-indigo-500 flex items-center justify-center font-bold text-white text-xs flex-shrink-0">
          {initials}
        </div>
        <div className="min-w-0">
          <p className="text-xs font-semibold text-white truncate">{companyName}</p>
          <p className="text-[9px] text-white/40 truncate">Company Account</p>
        </div>
      </div>

      <nav className="flex-1 px-2 py-3 overflow-y-auto space-y-0.5">
        <p className="px-3 py-1 text-[9px] font-bold uppercase tracking-widest text-white/30">Main Menu</p>
        {NAV_ITEMS.map(({ key, label, icon, badge, path }) => (
          <button key={key} onClick={() => { navigate(path); setSidebarOpen(false); }}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all ${activeNav === key ? "bg-blue-600 text-white" : "text-gray-300 hover:bg-white/10 hover:text-white"}`}>
            <Icon d={icon} size="w-4 h-4" />
            <span className="truncate">{label}</span>
            {badge && (
              <span className={`ml-auto text-[9px] font-bold px-1.5 py-0.5 rounded-full flex-shrink-0 ${activeNav === key ? "bg-white/20 text-white" : typeof badge === "number" ? "bg-red-500 text-white" : "bg-white/10 text-white/60"}`}>
                {badge}
              </span>
            )}
          </button>
        ))}

        <div className="border-t border-white/10 my-2" />
        <p className="px-3 py-1 text-[9px] font-bold uppercase tracking-widest text-white/30">Account</p>
        <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-red-300 hover:bg-red-500/10 transition-all">
          <LogOut className="w-4 h-4 flex-shrink-0" />
          <span>Logout</span>
        </button>
      </nav>

      

      <div className="px-3 pb-4 flex-shrink-0">
        <Link to="/post-load">
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-xl text-sm font-bold transition-colors flex items-center justify-center gap-2">
            <Plus className="w-4 h-4" /> Post New Load
          </button>
        </Link>
      </div>
    </aside>
  );
}